import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  username: '',
  balance: 0,
  authParams: {},
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set(state, action) {
      return { ...action.payload, requestTimestamp: state.requestTimestamp };
    },
    update(state, action) {
      return { ...state, ...action.payload };
    },
    clearSelectGame(state) {
      return {
        ...state,
        authParams: {
          ...state.authParams,
          selectGame: undefined,
        },
      };
    },
    failure() { /* do nothing */ },
    // Used to get the user session
    request() { return { requestTimestamp: Date.now() }; },
  },
});

export const user = userSlice.actions;
export default userSlice.reducer;
